<div class="subheader with-padding flgrow" style="position: relative" *ngIf="dealerList && dealerList.length > 0;">
    <div class="row" >
        <!-- Select Dealer -->
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
            <div>
                <label translate>
                    lblDealersName <strong class="mlt6 required"> * </strong>
                </label>
                <div class="relative flmid">
                    <div class="flgrow">
                        <app-dealer-searchbox-dropdown [dealerList]="dealerList" [(ngModel)]="dealerId"
                        [selectedDealer]="dealerId" ngDefaultControl name="dealerDropdown" 
                        (onSelectDealer)="onDealerSelected($event)"
                            placeholder="Search Dealer">
                        </app-dealer-searchbox-dropdown>
                    </div>
                </div>
            </div>
            <p *ngIf="isDealerRequired" class="help-block text-danger" translate>lblRequiredDealer</p>
        </div>
        <!-- Search -->
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="dealerList && dealerList.length > 0;">
            <div>
                <button type="button" (click)="onSearchReport()" class="btn btn-primary btn">
                    <em class="fa fa-search"></em>
                </button>
            </div>
        </div>
        <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
            <!-- Excel -->
            <button type="button" (click)="exportAsXLSX()" 
                ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px; margin-top: 1.1rem;">
                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
            </button>
            <!-- PDF -->
            <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" style="margin-top: -0.4rem;"
                ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                <em class="far fa-file fa-2x"></em>
                <span class="bdg">PDF</span>
            </button>
        </div>
    </div>
</div>
<div class="card m-2 scrollbar">
    <div class="table-responsive" infinite-scroll [scrollWindow]="false" *ngIf="showData">

        <ng-container *ngIf="showData; ">
            <table style="width:100%" class="table table-bordered fixed-column mb-0" aria-describedby="mechanicreport">
                <thead>
                    <tr>
                        <th scope="col" translate> lblMechanicName </th>
                        <th scope="col" translate> lblEmployeeNumber</th>
                        <th scope="col" translate> lblEfficiency</th>
                        <th scope="col" translate> lblSkillSet</th>
                        <th scope="col" translate> lblCompetence</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="mechanicReport?.length > 0; else load_else">
                        <ng-template ngFor let-mechanic [ngForOf]="mechanicReport" let-i="index">
                            <tr>
                                <td>{{mechanic.name}}</td>
                                <td>{{mechanic.employeeNo}}</td>
                                <td>{{mechanic.efficiency}}</td>
                                <td>{{mechanic.skillDescription}}</td>
                                <td>{{mechanic.competenceName}}</td>
                            </tr>
                        </ng-template>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                          <td colspan="8" class="no-record" translate>
                            lblNoRecordsFound
                          </td>
                        </tr>
                      </ng-template>
                </tbody>
            </table>
        </ng-container>
    </div>
</div>